import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { PATH_NAME } from '../constants'

const useMaintenance = () => {
    const MAINTENANCE = process.env.REACT_APP_MAINTENANCE
    const navigate = useNavigate()
    useEffect(() => {
        if (MAINTENANCE === 'true' || MAINTENANCE === 'clearLocalStorage') {
            navigate(PATH_NAME.Maintenance)
        }
    }, [MAINTENANCE])
}

export default useMaintenance
